import _ from 'lodash';
import { PRICE_SELECTED } from 'pu-data/QuoteSteps';

export const extractAssembly = (arg) => {
  const { quoteStep, parameters, quote, currentVariant } = arg;

  if (quoteStep !== PRICE_SELECTED) return {};

  const {
    row_selected,
    column_selected,
    supplier_selected,
  } = parameters;

  const lineItem = quote.line_items.find((li) => li.product_key === supplier_selected);
  if (!lineItem) return {};

  const price = _.round(lineItem.pricing[row_selected][column_selected], 2)
  const quantity = lineItem.options.quantities[row_selected];
  const leadTime = lineItem.lead_times[column_selected];

  const unitPrice = _.round((price / quantity), 2);
  return {
    quantity,
    leadTime,
    unitPrice,
    currentVariant,
    supplier: supplier_selected,
    subTotal: price,
    selected: true,
  };
}